import { render, staticRenderFns } from "./MaterialAdd.vue?vue&type=template&id=05e312ed&scoped=true&"
import script from "./MaterialAdd.vue?vue&type=script&lang=js&"
export * from "./MaterialAdd.vue?vue&type=script&lang=js&"
import style0 from "./MaterialAdd.vue?vue&type=style&index=0&id=05e312ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e312ed",
  null
  
)

export default component.exports